"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TEXTS_MAPPER = void 0;
exports.TEXTS_MAPPER = {
    Growth: { title: 'Hudled - Growth Plan', desc: 'Sign up to Hudled and get your full SaaS lifecycle under control' },
    'Start-Up': { title: 'Hudled - Startup Plan', desc: 'Join Hudled to seamlessly manage your SaaS spend, usage, and savings' },
    // None: { title: 'Hudled - Signup', desc: 'Get Hudled today and never overpay on your SaaS again' },
};
